import { Component, OnInit } from '@angular/core';
import { ICON } from '@core/util/icon';
import { take } from 'rxjs/operators';
import { UserProfileState } from '@state/user-profile';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ConfirmFirmModalComponent } from './confirm-firm-modal/confirm-firm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { BusinessDispatch, BusinessState } from '@state/business';
import { TitleInsuranceContact } from '@models/businesses';
import { isSet } from '@core/util/value';
import { TitleInsuranceContactInfoModalComponent } from 'src/app/private/sale/title-insurance/components/contact-info-modal/contact-info-modal.component';
import { TitleInsuranceProvider } from '@models/title-insurance';
import { BusinessAddressesState } from '@state/business/address';
import { ChicagoFirmNameOverrideComponent } from './chicago-firm-name-override/chicago-firm-name-override.component';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-profile-chicago',
	templateUrl: './chicago.component.html',
	styleUrls: ['./chicago.component.scss'],
	standalone: false,
})
export class ChicagoProfileComponent implements OnInit {
	public ICON = ICON;
	public connected = false;
	public benefits = [
		'Save time and reduce errors by leveraging existing data within Closer to prepopulate the majority of your electronic order',
		'Receive automated updates regarding the state of your order',
		'Request quick quotes on premiums',
		'Automatically download title insurance documents and fees directly to your files in Closer',
	];

	@ViewSelectSnapshot(UserProfileState.getProfileId) profileId: string;
	@ViewSelectSnapshot(BusinessState.chicagoFirmName) chicagoLawfirm: string;
	@ViewSelectSnapshot(BusinessState.chicagoContact)
	contact: TitleInsuranceContact;
	@Select(BusinessAddressesState.addressCount) officeCount$: Observable<number>;
	@Select(BusinessAddressesState.addressesWithChicagoOverrideCount)
	addressesWithChicagoOverrideCount$: Observable<number>;

	constructor(
		private dialog: MatDialog,
		private businessDispatch: BusinessDispatch,
	) {}

	ngOnInit(): void {
		this.connected = isSet(this.chicagoLawfirm);
	}

	connect(): void {
		const modalRef = this.dialog.open(ConfirmFirmModalComponent, {
			maxWidth: '600px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					this.connected = true;
					this.businessDispatch.SetChicagoFirmName(value);
				}
			});
	}

	openContactInfo(): void {
		this.dialog.open(TitleInsuranceContactInfoModalComponent, {
			data: {
				provider: TitleInsuranceProvider.CHICAGO,
			},
		});
	}

	openOfficeOverridesModal() {
		this.dialog.open(ChicagoFirmNameOverrideComponent);
	}
}
